import { createSelector } from 'reselect';

import { AppState } from '../../../../../../store/models/app-state';

const demandsState = (state: AppState) => state.demandDetail;

export const demandDetailPositionsDataSelector = createSelector(demandsState, state => state.positions.stepData);

/** What the step compares against to decide whether anything is unsaved. */
export const demandDetailPositionsBaselineSelector = createSelector(demandsState, state => state.positions.baseline);
export const demandDetailPositionsDeliverDateSelector = createSelector(demandsState, state => ({
    deliveryDateFrom: state.positions.stepData.values.deliveryDateFrom,
    deliveryDateTo: state.positions.stepData.values.deliveryDateTo,
}));
